import cn from 'classnames';
import { Grid, Icon, Modal, Panel } from 'ht-styleguide';
import { TGenericModalProps } from '@scenes/HomeHub/homehub.types';
import styles from './chatphone.module.scss';
import { HT_INFO_PHONE } from '@constants/hellotech';
import ChatLink from '@integrations/gladly/Chat/ChatLink';

const ChatPhoneModal = ({ isVisible, hide }: TGenericModalProps) => {
  const handleCallPhone = () => {
    window.open(HT_INFO_PHONE.customers.alternativeOne.link, '_self');
  };

  return (
    <Modal
      isVisible={isVisible}
      hide={hide}
      header="Want to speak to a real person instead?"
      headerClasses="marginBottom-tiny1"
      subheader="Available to assist you between 7 AM and 9 PM."
    >
      <Grid.Fluid classes="marginAuto">
        <Grid.Row classes={styles.row}>
          <Grid.Column sm={4} md={4} lg={6} classes={styles.columnLeft}>
            <ChatLink
              showIcon
              linkText="Chat with an agent"
              iconClasses={styles.icon}
              classesText={cn(styles.text, 'paddingTop-small')}
              classesContainer={cn(styles.panel, 'paddingTop-medium cursorPointer paddingBottom-medium text-align-center')}
            />
          </Grid.Column>
          <Grid.Column sm={4} md={4} lg={6} classes={styles.columnRight}>
            <div className="cursorPointer" onClick={handleCallPhone}>
              <Panel noShadow largeBorderRadius className={cn(styles.panel, 'paddingTop-medium paddingBottom-medium text-align-center')}>
                <Icon name="phone-outlined" className={styles.icon} />
                <h6 className="paddingTop-small">{`Call ${HT_INFO_PHONE.customers.alternativeOne.title}`}</h6>
              </Panel>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </Modal>
  );
};

export default ChatPhoneModal;
